import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Salesperformance.css';
import FormAside from "./FormAside"
import { FaCheckCircle, FaEnvelope, FaWhatsapp } from 'react-icons/fa';  // Importing the Font Awesome check-circle and envelope icons
import FormNotification from './FormNotification';
import { FaFontAwesome } from 'react-icons/fa';
import MarketingdashboardAside from './MarketingdashboardAside';
function SalesPerformanceManager() {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');
  const [formData, setFormData] = useState({
    empId: '',
    empName: '',
    designation: '',
    institutename: '',
    instituteaddress: '',
    contactperson: '',
    contactpersondesignation: '',
    contactpersonnumber: '',
    contactpersonemail: '',
    followupdate: '',
    comment: '',
    interestshown: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [selectedInterest, setSelectedInterest] = useState('');
  const [employeeRecords, setEmployeeRecords] = useState([]);
  const [showRecords, setShowRecords] = useState(false);
  const [schoolHistoryRecords, setSchoolHistoryRecords] = useState([]);
  const [schoolHistoryLoading, setSchoolHistoryLoading] = useState(false);
  const [schoolHistoryError, setSchoolHistoryError] = useState('');
  const [showShareEmployeeModal, setShowShareEmployeeModal] = useState(false);
  const [shareEmployeeList, setShareEmployeeList] = useState([]);
  const [shareEmployeeLoading, setShareEmployeeLoading] = useState(false);
  const [shareEmployeeError, setShareEmployeeError] = useState('');
  const [shareSourceRecord, setShareSourceRecord] = useState(null);
  const selectedEmployee = employees.find(
    (employee) => String(employee.empId) === String(selectedEmployeeId)
  );

  const expandMouRows = (records) => {
    const expanded = [];

    records.forEach((record) => {
      expanded.push({
        ...record,
        rowType: record.rowType || 'base',
      });

      if (record.mouSubmittedDate && record.mouSubmittedDate !== '-') {
        expanded.push({
          ...record,
          rowType: 'mou-submitted',
          comment: 'MOU Submitted',
          followupdate: record.mouSubmittedDate,
          lastfollowupdate: record.mouSubmittedDate,
        });
      }

      if (record.mouPaidDate && record.mouPaidDate !== '-') {
        expanded.push({
          ...record,
          rowType: 'payment-received',
          comment: 'Payment Received',
          followupdate: record.mouPaidDate,
          lastfollowupdate: record.mouPaidDate,
        });
      }
    });

    return expanded;
  };

  const formatDisplayDate = (dateValue) => {
    if (!dateValue || dateValue === '-') return '-';

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) {
      return '-';
    }

    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const fetchSchoolHistory = async (empId) => {
    if (!empId) return;

    try {
      console.log('[SalesPerformance] fetching school history for empId:', empId);
      setSchoolHistoryLoading(true);
      setSchoolHistoryError('');

      const response = await axios.get(
        `https://cleezoclass.com:8443/api/sales-performance-schools/${empId}`
      );

     const mouresponse = await axios.get(`https://cleezoclass.com:8443/api/reports/mou-forms`)

    
     console.log(mouresponse.data)
      console.log('[SalesPerformance] school history response:', response.data);
      setSchoolHistoryRecords(expandMouRows(Array.isArray(response.data) ? response.data : []));

    } catch (error) {
      console.error('[SalesPerformance] error fetching school history:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        url: error.config?.url,
      });
      try {
        console.log('[SalesPerformance] falling back to sales-performance-table for empId:', empId);
        const fallbackResponse = await axios.get(
          `https://cleezoclass.com:8443/api/sales-performance-table/${empId}`
        );
        const mouForm = await axios.get(`https://cleezoclass.com:8443/api/reports/mou-forms${empId}`);

        console.log(mouForm)
        const mouRecords = Array.isArray(mouForm.data) ?
          mouForm.data.map((record) => ({
            mouAttachament: record.mou_file_path || '-'
          })) : [];
        const fallbackRecords = Array.isArray(fallbackResponse.data)
          ? fallbackResponse.data.map((record) => ({
            empName: formData.empName,
            institutename: record.institutename || '-',
            instituteaddress: record.instituteaddress || '-',
            contactperson: record.contactperson || '-',
            contactpersondesignation: record.contactpersondesignation || '-',
            contactpersonnumber: record.contactpersonnumber || '-',
            startdate: record.created_at || record.followupdate || null,
            followupdate: record.followupdate || '-',
            lastfollowupdate: record.created_at || record.followupdate || null,
            mouStatus: record.mouStatus || 'Not Submitted',
            mouSubmittedDate: record.mouSubmittedDate || '-',
            mouPaidDate: record.mouPaidDate || '-',
            comment: record.comment || '-',



          }))
          : [];

        console.log('[MOU attachement]')
        console.log('[SalesPerformance] fallback school history response:', fallbackRecords);
        setSchoolHistoryRecords(expandMouRows(fallbackRecords));
        setSchoolHistoryError('');
      } catch (fallbackError) {
        console.error('[SalesPerformance] fallback school history error:', {
          message: fallbackError.message,
          status: fallbackError.response?.status,
          data: fallbackError.response?.data,
          url: fallbackError.config?.url,
        });
        setSchoolHistoryError(
          error.response?.data?.error || 'Unable to fetch school history'
        );
        setSchoolHistoryRecords([]);
      }
    } finally {
      setSchoolHistoryLoading(false);
    }
  };

  const openShareEmployeeModal = async (record) => {
    try {
      setShareSourceRecord(record);
      setShareEmployeeLoading(true);
      setShareEmployeeError('');

      const response = await axios.get(
        'https://cleezoclass.com:8443/api/employee-names'
      );

      console.log('[SalesPerformance] employees loaded for share:', response.data);
      setShareEmployeeList(Array.isArray(response.data) ? response.data : []);
      setShowShareEmployeeModal(true);
    } catch (error) {
      console.error('[SalesPerformance] error loading employee names:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        url: error.config?.url,
      });
      setShareEmployeeError('Unable to load employees.');
      setShowShareEmployeeModal(true);
    } finally {
      setShareEmployeeLoading(false);
    }
  };

  const shareRecordToEmployee = async (selectedEmployee) => {
    if (!shareSourceRecord || !selectedEmployee?.empId) return;

    try {
      const response = await axios.post(
        'https://cleezoclass.com:8443/api/share-school-history',
        {
          empId: selectedEmployee.empId,
          empName: selectedEmployee.empName,
          designation: selectedEmployee.designation || formData.designation,
          sharedByEmpId: formData.empId,
          sharedByEmpName: formData.empName,
          sharedByDesignation: formData.designation,
          institutename: shareSourceRecord.institutename,
          instituteaddress: shareSourceRecord.instituteaddress || '',
          contactperson: shareSourceRecord.contactperson || '',
          contactpersondesignation: shareSourceRecord.contactpersondesignation || '',
          contactpersonnumber: shareSourceRecord.contactpersonnumber || '',
          contactpersonemail: shareSourceRecord.contactpersonemail || '',
          interestshown: shareSourceRecord.interestshown || 'Follow Up',
          comment: `Shared to ${selectedEmployee.empName} by ${formData.empName}`,
        }
      );

      console.log('[SalesPerformance] share response:', response.data);
      if (response.status === 200) {
        setSuccessMessage(`Shared with ${selectedEmployee.empName} successfully.`);
        localStorage.setItem('salesPerformanceRefreshAt', Date.now().toString());
        window.dispatchEvent(new Event('salesPerformanceRefresh'));
        setShowShareEmployeeModal(false);
        setShareSourceRecord(null);
        setTimeout(() => setSuccessMessage(''), 5000);
      }
    } catch (error) {
      console.error('Error sharing school history:', error);
      setErrorMessage('Unable to share school history.');
    }
  };

  const handleClick = (interest, color) => {
    setFormData({ ...formData, interestshown: interest });
    setSelectedInterest(color);
  };

  // Inside your component, alongside handleMailClick
  const handleWhatsappClick = () => {
    const phone = formData.contactpersonnumber; // make sure it's in international format
    const message = `Hello ${formData.contactperson}, this is ${formData.empName} from ${formData.institutename}.`;
    const whatsappURL = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, 'whatsappWindow');

  };

  // Handle mail icon click
  const handleMailClick = async () => {
    try {
      const email = formData.contactpersonemail;

      // Debugging: Check email
      console.log("Email to be sent: ", email);

      if (!email) {
        console.error("No email provided in the form data");
        setErrorMessage('No email provided!'); // Update UI with error
        return;  // Stop if no email
      }

      // Send the POST request to backend
      const response = await axios.post(
        'https://cleezoclass.com:8443/api/send-email',
        {
          email: formData.contactpersonemail,
          contactperson: formData.contactperson,
          institutename: formData.institutename,
          empName: formData.empName,
        }
      );


      // Check if the email was sent successfully
      if (response.status === 200) {
        setSuccessMessage('Email sent successfully!');
      } else {
        setErrorMessage('Failed to send email!');
      }
    } catch (error) {
      console.error('Error sending email:', error.response ? error.response.data : error.message);
      // Update the UI with error message
      setErrorMessage('Error sending email.');
    }
  };


  const handleViewMyData = async () => {
    try {
      const empIdToUse = selectedEmployeeId || formData.empId;
      const response = await axios.get(
        `https://cleezoclass.com:8443/api/sales-performance-table/${empIdToUse}`

      );

      setEmployeeRecords(response.data);
      setShowRecords(true);
    } catch (error) {
      console.error('Error fetching employee data:', error);
      setErrorMessage('Unable to fetch your records');
    }
  };


  // Fetch employee details from localStorage
  useEffect(() => {
    const loadEmployees = async () => {
      try {
        const response = await axios.get(
          'https://cleezoclass.com:8443/api/employee-names'
        );

        setEmployees(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error('Error fetching employees:', error);
        setEmployees([]);
      }
    };

    loadEmployees();
  }, []);

  useEffect(() => {
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');

    if (storedEmpId && storedEmpName && storedDesignation) {
      setSelectedEmployeeId(storedEmpId);
      setFormData((prevData) => ({
        ...prevData,
        empId: storedEmpId,
        empName: storedEmpName,
        designation: storedDesignation,
      }));
    } else {
      alert('Session expired or employee details not found. Please log in again.');
      window.location.href = '/login';
    }
  }, []);

  useEffect(() => {
    if (selectedEmployeeId) {
      fetchSchoolHistory(selectedEmployeeId);
    }
  }, [selectedEmployeeId]);

  useEffect(() => {
    if (!selectedEmployee) return;

    setFormData((prevData) => ({
      ...prevData,
      empId: selectedEmployee.empId,
      empName: selectedEmployee.empName,
      designation: selectedEmployee.designation || prevData.designation,
    }));
  }, [selectedEmployee]);

  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === 'salesPerformanceRefreshAt' && selectedEmployeeId) {
        fetchSchoolHistory(selectedEmployeeId);
      }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [selectedEmployeeId]);

  useEffect(() => {
    const handleRefresh = () => {
      if (selectedEmployeeId) {
        fetchSchoolHistory(selectedEmployeeId);
      }
    };

    window.addEventListener('salesPerformanceRefresh', handleRefresh);
    return () => window.removeEventListener('salesPerformanceRefresh', handleRefresh);
  }, [selectedEmployeeId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submit triggered');

    // Ensure required fields are filled
    if (
      !formData.institutename ||
      !formData.instituteaddress ||
      !formData.contactperson ||
      !formData.contactpersondesignation ||
      !formData.followupdate ||
      !formData.comment ||
      !formData.interestshown
    ) {
      console.warn('Validation failed: Missing required fields');
      setErrorMessage('All fields are required');
      return;
    }

    console.log('Validation passed');

    try {
      console.log('Sending POST request to API...');

      const response = await axios.post(
        'https://cleezoclass.com:8443/api/sales-performance-table',
        formData,
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      console.log('API response:', response);

      setSuccessMessage('Data saved successfully!');
      setErrorMessage('');

      // Optionally reset form after a delay or user action (not immediately)
      setFormData({
        empId: formData.empId,
        empName: formData.empName,
        designation: formData.designation,
        institutename: '',
        instituteaddress: '',
        contactperson: '',
        contactpersondesignation: '',
        contactpersonnumber: '',
        contactpersonemail: '',
        followupdate: '',
        comment: '',
        interestshown: '',
      });

    } catch (error) {
      console.error('API Error:', error);
      setErrorMessage('Error: Something went wrong.');
      setSuccessMessage('');
    }
  };



  return (
    <>
      <style>{`
      /* Modal Overlay */
      .sales-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.55);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
      }

      /* Modal Content */
      .sales-modal-content {
        background: #ffffff;
        padding: 20px 25px;
        border-radius: 10px;
        width: 90%;
        max-width: 900px;
        max-height: 80vh;
        overflow-y: auto;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
        animation: scaleIn 0.25s ease;
      }

      /* Animation */
      @keyframes scaleIn {
        from {
          transform: scale(0.9);
          opacity: 0;
        }
        to {
          transform: scale(1);
          opacity: 1;
        }
      }

      /* Table polish */
      .sales-performance-table {
        width: 100%;
        min-width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        margin-top: 15px;
      }

      .sales-performance-table th,
      .sales-performance-table td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: anywhere;
      }

      .sales-performance-table th {
        background-color: #0a3d62;
        font-weight: 600;
        color:#fff;
        font-size: 0.95rem;
        position: sticky;
        top: 0;
        z-index: 2;
        box-shadow: 0 1px 0 #ddd;
      }

 
      .sales-school-history-card {
        width: 100%;
        margin-top: 14px;
        background: #ffffff;
        border-radius: 10px;
        padding: 20px 24px;
        box-sizing: border-box;
        height: 90vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .sales-school-history-header {
        margin: 0 0 12px;
        color: #2f3b52;
      }
      .sales-school-history-meta {
        margin: 0 0 14px;
        color: #64748b;
        font-size: 0.95rem;
      }
      .sales-school-history-table-wrapper {
        flex: 1;
        overflow: auto;
        width: 100%;
      }
      .sales-school-history-table-wrapper table {
        width: 100%;
        min-width: 100%;
      }
        /* Whole section */
.action-row {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

/* Buttons group */
.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
}

/* Secondary button */
.sales-performance-button.secondary {
  background: #f1f3f6;
  color: #333;
}

/* Icons group */
.action-icons {
  display: flex;
  justify-content: center;
  gap: 30px;
}

/* Icon cards */
.icon-card {
  width: 110px;
  height: 95px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 34px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
}

.icon-card span {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 600;
}

/* Email */
.icon-card.mail {
  background: #eef3ff;
  color: #3b6cff;
}

/* WhatsApp */
.icon-card.whatsapp {
  background: #e7f8ef;
  color: #25d366;
}

/* Hover */
.icon-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.25);
}



    `}</style>
      <div className="sales-performance-page-container ">
        <div className="sales-employee-selector-row">
          <div className="marketing-dashboard-select">
            <select
              value={selectedEmployeeId}
              onChange={(e) => setSelectedEmployeeId(e.target.value)}
            >
              {employees.map((employee) => (
                <option key={employee.empId} value={employee.empId}>
                  {employee.empName} - {employee.designation}
                </option>
              ))}
            </select>
          </div>

        </div>
        <FormNotification />

        <MarketingdashboardAside />

        <h2 className="sales-performance-page-header">Sales Performance Form</h2>

        <form onSubmit={handleSubmit} className="follow-up-container">
          {/* Row 1: Employee Details */}
          <div className="sales-performance-form-row">
            <div className="sales-performance-form-group">
              <label>Employee Name:</label>
              <input type="text" name="empName" value={formData.empName} readOnly />
            </div>
            <div className="sales-performance-form-group">
              <label>Employee ID:</label>
              <input type="text" name="empId" value={formData.empId} readOnly />
            </div>

            <div className="sales-performance-form-group">
              <label>Designation:</label>
              <input type="text" name="designation" value={formData.designation} readOnly />
            </div>
          </div>

          {/* Row 2: Institute Details & Contact Person */}
          <div className="sales-performance-form-row">
            <div className="sales-performance-form-group">
              <label>Institute Name:</label>
              <input type="text" name="institutename" value={formData.institutename} onChange={handleChange} />
            </div>
            <div className="sales-performance-form-group">
              <label>Institute Address:</label>
              <input type="text" name="instituteaddress" value={formData.instituteaddress} onChange={handleChange} />
            </div>
            <div className="sales-performance-form-group">
              <label>Contact Person Number:</label>
              <input type="text" name="contactpersonnumber" value={formData.contactpersonnumber} onChange={handleChange} />
            </div>
          </div>

          {/* Row: Contact Person Details */}
          <div className="sales-performance-form-row">
            <div className="sales-performance-form-group">
              <label>Contact Person Name:</label>
              <input
                type="text"
                name="contactperson"
                value={formData.contactperson}
                onChange={handleChange}
              />
            </div>
            <div className="sales-performance-form-group">
              <label>Contact Person Designation:</label>
              <input
                type="text"
                name="contactpersondesignation"
                value={formData.contactpersondesignation}
                onChange={handleChange}
              />
            </div>
            <div className="sales-performance-form-group">
              <label>Contact Person Email:</label>
              <input
                type="email"
                name="contactpersonemail"
                value={formData.contactpersonemail}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Row 4: Follow-Up Date, Comment, Interest Shown, Actions */}
          <div className="sales-performance-form-row sales-performance-actions-row">
            <div className="sales-performance-form-group">
              <label>Follow-Up Date:</label>
              <input
                type="date"
                name="followupdate"
                value={formData.followupdate}
                onChange={handleChange}
              />
            </div>
            <div className="sales-performance-form-group">
              <label>Comment:</label>
              <textarea name="comment" value={formData.comment} onChange={handleChange}></textarea>
            </div>
            <div className="sales-performance-form-group">
              <label>Interest Shown:</label>
              <div className="sales-performance-interest-circles">
                <div
                  className={`sales-performance-interest-circle ${selectedInterest === 'red' ? 'selected' : ''}`}
                  style={{ backgroundColor: 'red' }}
                  onClick={() => handleClick('Not Interested', 'red')}
                  title="Not Interested"
                ></div>
                <div
                  className={`sales-performance-interest-circle ${selectedInterest === 'yellow' ? 'selected' : ''}`}
                  style={{ backgroundColor: 'yellow' }}
                  onClick={() => handleClick('Follow Up', 'yellow')}
                  title="Follow Up"
                ></div>
                <div
                  className={`sales-performance-interest-circle ${selectedInterest === 'green' ? 'selected' : ''}`}
                  style={{ backgroundColor: 'green' }}
                  onClick={() => handleClick('Interested', 'green')}
                  title="Interested"
                ></div>
              </div>
            </div>

          </div>
          <div className="sales-performance-form-group sales-performance-action-group">
            <div className="action-buttons">
              <button type="submit">Submit</button>
              <button type="button" onClick={handleViewMyData}>
                My Leads              </button>
            </div>

            {successMessage && (
              <div className="action-icons">
                <div className="icon-card mail" onClick={handleMailClick}>
                  <FaEnvelope />
                  <span>Email</span>
                </div>

                <div className="icon-card whatsapp" onClick={handleWhatsappClick}>
                  <FaWhatsapp />
                  <span>WhatsApp</span>
                </div>
              </div>
            )}
          </div>
          {/* Submit Button Row */}
          {/* <div className="action-row">
  <div className="action-buttons">
    <button type="submit" >
      Submit
    </button>

    <button
      type="button"
      onClick={handleViewMyData}
    >
      View Data
    </button>
  </div>

  {successMessage && (
    <div className="action-icons">
      <div className="icon-card mail" onClick={handleMailClick}>
        <FaEnvelope />
        <span>Email</span>
      </div>

      <div className="icon-card whatsapp" onClick={handleWhatsappClick}>
        <FaWhatsapp />
        <span>WhatsApp</span>
      </div>
    </div>
  )}
</div> */}


          <div className="sales-school-history-card">

            {!selectedEmployeeId ? (
              <p>Loading employee details...</p>
            ) : schoolHistoryLoading ? (
              <p>Loading school history...</p>
            ) : schoolHistoryError ? (
              <p className="sales-performance-error-message" style={{ marginTop: 0 }}>
                {schoolHistoryError}
              </p>
            ) : schoolHistoryRecords.length > 0 ? (
              <div className="sales-school-history-table-wrapper">
                <table className="sales-performance-table">
                  <thead>
                    <tr>
                      <th>Employee Name</th>
                      <th>Institute Name</th>
                      <th>Address</th>
                      <th>Contact Name</th>
                      <th>Contact Designation</th>
                      <th>Contact Number</th>
                      <th>Start Date</th>
                      <th>Follow-Up Date</th>
                      <th>Newest on Top</th>
                      <th >Comment</th>
                      <th>MOU Attachment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {schoolHistoryRecords.map((record, index) => (
                      (() => {
                        const rowColor =
                          record.rowType === 'mou-submitted'
                            ? '#047857'
                            : record.rowType === 'payment-received'
                              ? '#1d4ed8'
                              : 'inherit';

                        return (
                          <tr
                            key={`${record.institutename}-${index}`}
                            style={{ color: rowColor }}
                          >

                            <td style={{ color: rowColor }}>{record.empName || '-'}</td>
                            <td style={{ color: rowColor }}>{record.institutename || '-'}</td>
                            <td style={{ color: rowColor }}>{record.instituteaddress || '-'}</td>
                            <td style={{ color: rowColor }}>{record.contactperson || '-'}</td>
                            <td style={{ color: rowColor }}>{record.contactpersondesignation || '-'}</td>
                            <td style={{ color: rowColor }}>{record.contactpersonnumber || '-'}</td>
                            <td style={{ color: rowColor }}>{formatDisplayDate(record.startdate)}</td>
                            <td style={{ color: rowColor }}>{formatDisplayDate(record.followupdate)}</td>
                            <td style={{ color: rowColor }}>{formatDisplayDate(record.lastfollowupdate)}</td>
                           

                            <td
                              style={{
                                color: record.comment?.includes('Shared to') ? 'green' : 'inherit',
                                fontWeight: record.comment?.includes('Shared to') ? '600' : 'normal',
                              }}
                            >{record.comment || '-'}</td>
                             <td style={{ color: rowColor }}>{record.mouAttachament||'No Attachment' }</td>
                          </tr>
                        );
                      })()
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>No schools found for this employee.</p>
            )}
          </div>
        </form>
        {showRecords && (
          <div className="sales-modal-overlay" onClick={() => setShowRecords(false)}>
            <div
              className="sales-modal-content"
              onClick={(e) => e.stopPropagation()} // prevent close on inside click
            >
              <h3>My Submitted Records</h3>

              {employeeRecords.length > 0 ? (
                <table className="sales-performance-table">
                  <thead>
                    <tr>
                      <th>Institute</th>
                      <th>Contact Person</th>
                      <th>Date</th>
                      <th>Interest</th>
                      <th>Comment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employeeRecords.map((record, index) => (
                      <tr key={index}>
                        <td>{record.institutename}</td>
                        <td>{record.contactperson}</td>
                        <td>
                          {new Date(record.followupdate).toLocaleDateString('en-GB', {
                            day: '2-digit', month: 'short', year: 'numeric'
                          })}
                        </td>
                        <td>{record.interestshown}</td>
                        <td>{record.comment}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>No records found</p>
              )}
            </div>
          </div>
        )}



        {/* Show success icon and message after form submission */}
        {successMessage && (
          <div className="sales-performance-success-message">
            <FaCheckCircle style={{ color: 'green', marginRight: '10px' }} /> {/* Success icon */}
            {successMessage}
          </div>
        )}




        {errorMessage && <div className="sales-performance-error-message">{errorMessage}</div>}

        {showShareEmployeeModal && (
          <div className="sales-modal-overlay" onClick={() => setShowShareEmployeeModal(false)}>
            <div
              className="sales-modal-content"
              onClick={(e) => e.stopPropagation()}
              style={{ maxWidth: '700px' }}
            >
              <h3>Select Employee to Share With</h3>
              <p style={{ marginTop: 0, color: '#64748b' }}>
                Sharing: {shareSourceRecord?.institutename || '-'}
              </p>

              {shareEmployeeLoading ? (
                <p>Loading employees...</p>
              ) : shareEmployeeError ? (
                <p className="sales-performance-error-message">{shareEmployeeError}</p>
              ) : (
                <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                  {shareEmployeeList.length > 0 ? (
                    shareEmployeeList.map((employee) => (
                      <button
                        key={employee.empId || employee.empName}
                        type="button"
                        onClick={() => shareRecordToEmployee(employee)}
                        style={{
                          display: 'block',
                          width: '100%',
                          textAlign: 'left',
                          marginBottom: '8px',
                          padding: '10px 12px',
                          border: '1px solid #ddd',
                          borderRadius: '8px',
                          background: '#fff',
                          cursor: 'pointer',
                          color: '#000'
                        }}
                      >
                        {employee.empName}
                        {employee.empId ? ` (${employee.empId})` : ''}
                        {employee.designation ? ` - ${employee.designation}` : ''}
                      </button>
                    ))
                  ) : (
                    <p>No employees found.</p>
                  )}
                </div>
              )}

              <button
                type="button"
                onClick={() => setShowShareEmployeeModal(false)}
                className="sales-performance-button secondary"
                style={{ marginTop: '14px' }}
              >
                Close
              </button>
            </div>
          </div>
        )}

      </div>
    </>
  );
}

export default SalesPerformanceManager;
